import { render, staticRenderFns } from "./SeeMoreBtn.vue?vue&type=template&id=c3c0fa0a&scoped=true&"
import script from "./SeeMoreBtn.vue?vue&type=script&lang=js&"
export * from "./SeeMoreBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c0fa0a",
  null
  
)

export default component.exports